// extracted by mini-css-extract-plugin
module.exports = {"BlueFont":"navbar-module--BlueFont--9WjTi","navli":"navbar-module--navli--3XBND"};